
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    to: {
      type: String,
      default: ''
    },
    href: {
      type: String,
      default: ''
    },
    variant: {
      type: String,
      default: 'light'
    },
    size: {
      type: String,
      default: ''
    }
  },

  computed: {
    type() {
      return this.to ? 'router-link' : (this.href ? 'a' : 'button')
    }
  }
})
